import React, { useEffect } from 'react'
import { Outlet } from 'react-router'

import { useMainGlobalContext } from '../../context/GlobalContext'
import Spinner from '../../components/loading/Spinner'

const Checkpoint: React.FC = () => {
  const { state } = useMainGlobalContext()
  // const [theme, setTheme] = useState('dark')

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      !customElements.get('custom-create-post')
    ) {
      import('../../components/custom/components/CustomCreatePost')
        .then(({ CustomCreatePost }) => {
          customElements.define('custom-create-post', CustomCreatePost)
        })
        .catch((err) => console.error('Failed to load custom element:', err))
    }

    if (
      typeof window !== 'undefined' &&
      !customElements.get('custom-error-display')
    ) {
      import('../../components/custom/components/CustomErrorDisplay')
        .then(({ CustomErrorDisplay }) => {
          customElements.define('custom-error-display', CustomErrorDisplay)
        })
        .catch((err) => console.error('Failed to load custom element:', err))
    }

    if (
      typeof window !== 'undefined' &&
      !customElements.get('custom-create-reply')
    ) {
      import('../../components/custom/components/CustomCreateReply')
        .then(({ CustomCreateReply }) => {
          customElements.define('custom-create-reply', CustomCreateReply)
        })
        .catch((err) => console.error('Failed to load custom element:', err))
    }
  }, [])

  const loadingComponent = (
    <div className="flex h-dvh w-dvw items-center justify-center">
      <Spinner />
    </div>
  )

  return (
    <main>
      {state.globalLoading ? (
        loadingComponent
      ) : (
        <>
          <Outlet />
          {/* <button
            onClick={() => {
              if (theme === 'dark') {
                document.documentElement.setAttribute('data-theme', 'light')
                setTheme('light')
              } else {
                document.documentElement.setAttribute('data-theme', 'dark')
                setTheme('dark')
              }
            }}
            className="fixed top-[300px] left-[30px] z-[80] cursor-pointer bg-blue-500 p-[10px] text-white"
          >
            toggle theme
          </button> */}
        </>
      )}
    </main>
  )
}

export default Checkpoint
